import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    LinkItemLinkType,
    NavigationPanel,
} from 'src/domains/layouts/webview/components/navigationPanel/NavigationPanel';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AllSports } from 'src/domains/layouts/state/allSports/AllSports';
import { SidebarLoaderComponent } from 'src/domains/layouts/webview/modules/layoutSkeleton/NavigationSidebar/sidebarLoaderComponent/SidebarLoaderComponent';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

const NavigationSidebarSectionAZFavourites = observer(
    'NavigationSidebarSectionAZFavourites',
    (): React.ReactElement => {
        const common = useCommon();
        const appLayoutsState = AppLayoutsState.get(common);
        const { navigationFavourites } = appLayoutsState;

        const favouritesListView = navigationFavourites.favouritesListView.map(
            (item): LinkItemLinkType => ({
                ...item,
                iconType: 'StarFill',
                iconClick: (): void => {
                    navigationFavourites.setFavourites(item.to.id, false);
                },
            })
        );

        const restListView = navigationFavourites.restListView.map(
            (item): LinkItemLinkType => ({
                ...item,
                iconType: 'StarOutline',
                iconClick: (): void => {
                    navigationFavourites.setFavourites(item.to.id, true);
                },
            })
        );

        return (
            <>
                <NavigationPanel
                    title={
                        <I18n
                            langKey='left-menu.sports-az.favourites-active'
                            defaultText='Your Favourites'
                        />
                    }
                    titleDataTest='your-favourites'
                    links={favouritesListView}
                    typeTag='sport'
                />
                <NavigationPanel
                    title={
                        <I18n
                            langKey='left-menu.sports-az.favourites-rest'
                            defaultText='A-Z Betting'
                        />
                    }
                    titleDataTest='a-z-betting'
                    links={restListView}
                    typeTag='sport'
                />
            </>
        );
    }
);

const NavigationSidebarSectionAZDefault = observer('NavigationSidebarSectionAZDefault', (): React.ReactElement => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const { sportsList } = appLayoutsState;
    const { sportsLinks } = sportsList;

    const allSports = AllSports.get(common);

    const isLoading = allSports.allSportsWithActiveEvent === 'loading';

    if (isLoading) {
        return <SidebarLoaderComponent />;
    }

    return (
        <NavigationPanel
            title={
                <I18n
                    langKey='left-menu.sports-az-betting.title'
                    defaultText='A-Z Betting'
                />
            }
            titleDataTest='a-z-betting'
            links={sportsLinks}
            typeTag='sport'
        />
    );
});

export const NavigationSidebarSectionAZ = observer('NavigationSidebarSectionAZ', (): React.ReactElement => {
    const common = useCommon();
    const { session } = common;
    const configComponents = ConfigComponents.get(common).config;

    if (configComponents.navigationFavourites && session.isAuthorized) {
        return <NavigationSidebarSectionAZFavourites />;
    }

    return <NavigationSidebarSectionAZDefault />;
});
